import insertImageFromExistingInlineAttachment from '../actions/insertImageFromExistingInlineAttachment';
import { lazyConvertImageViewAttachmentToInlineAttachment } from 'owa-attachment-well-data';
export default function moveAttachmentToInlineHandler(composeViewState, attachment, contentId) {
    lazyConvertImageViewAttachmentToInlineAttachment.importAndExecute(composeViewState.attachmentWell, attachment, contentId);
    insertImageFromExistingInlineAttachment(composeViewState, contentId);
}
//# sourceMappingURL=moveAttachmentToInlineHandler.js.map